// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__Hugox","fileDisabled":"File_fileDisabled__2RwrL"};